import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { usePermission } from '@juvare/contact-management/ui/hooks';
import { getSettings } from '@juvare/platform-sdk-react/ui/features/editable-settings';
import { Box, Tab, Tabs } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { useMissionsTranslation } from '../../hooks';
import { useMissionTab } from '../mission/hooks/useMissionTab';
import { useMissionsAnalytics } from '../mission/hooks/useMissionsAnalytics';
import { ManageMissions } from './components/ManageMissions';
import { MissionListHeader } from './components/MissionListHeader';
import { MyMissions } from './components/MyMissions';
export const MissionListPage = () => {
    const { t } = useMissionsTranslation();
    const settings = useSelector(getSettings);
    const { requireAnySystemPermission } = usePermission();
    const { totalMissionsCount, totalVolunteersHours, fetchMissionAnalytics } = useMissionsAnalytics();
    const { missionTab, setMissionTab } = useMissionTab();
    const allowMissionChange = requireAnySystemPermission('manage-missions', 'manage-all-admin-missions');
    return (React.createElement(Box, null,
        React.createElement(MissionListHeader, { appTitle: settings.appTitle, missionsCount: totalMissionsCount, volunteerHours: totalVolunteersHours }),
        React.createElement(React.Fragment, null,
            React.createElement(Box, { sx: {
                    pl: 4,
                    borderBottom: 1,
                    borderColor: themeColors.border.main,
                    boxShadow: 1,
                    zIndex: 1,
                } },
                React.createElement(Tabs, { variant: 'scrollable', value: missionTab, onChange: (_event, value) => {
                        setMissionTab(value);
                    } },
                    allowMissionChange && (React.createElement(Tab, { label: t('missions.tabs.manageMissions'), value: 'manageMissions', "data-test": 'manage-missions-tab' })),
                    React.createElement(Tab, { label: t('missions.tabs.myMissions'), value: 'myMissions', "data-test": 'my-missions-tab' }))),
            allowMissionChange && missionTab === 'manageMissions' && (React.createElement(ManageMissions, { onFetchMissionAnalytics: fetchMissionAnalytics })),
            missionTab === 'myMissions' && React.createElement(MyMissions, null))));
};
